module.exports = __webpack_public_path__ + "img/doctor.fa5d4ade.png";